(function () {
  var LCPL_SCROLL_EPS = 2;
  var LCPL_PREFETCH_IDLE_TIMEOUT_MS = 1800;
  var LCPL_PREFETCH_FALLBACK_DELAY_MS = 420;
  var LCPL_SCROLL_PREFETCH_RATIO = 0.52;
  var LCPL_SCROLL_PREFETCH_THROTTLE_MS = 280;

  var LCPL_EYE_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" class="icon quick-action-icon" viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><path d="m20 20-3.5-3.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var LCPL_CART_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-quick-action" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M7 8.4h10l-.8 10.15A1.55 1.55 0 0 1 14.67 20H9.33A1.55 1.55 0 0 1 7.8 18.55L7 8.4Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/><path d="M9.45 8.4V7.05a2.55 2.55 0 0 1 5.1 0V8.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  var LCPL_SPINNER_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"/></svg>';
  function escapeHtml(s) {
    if (s == null) return '';
    var d = document.createElement('div');
    d.textContent = String(s);
    return d.innerHTML;
  }

  function lcplEscapeAttr(s) {
    if (s == null) return '';
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  }

  function lcplSubmitBuyNow(btn) {
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    if (btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('lcpl__cta--loading');
    var cartAddUrl = typeof routes !== 'undefined' && routes.cart_add_url ? routes.cart_add_url : '/cart/add';
    var fd = new FormData();
    fd.append('id', vid);
    fd.append('quantity', '1');
    var config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
      body: fd,
    };
    delete config.headers['Content-Type'];
    fetch(cartAddUrl, config)
      .then(function (r) {
        return r.json();
      })
      .then(function (response) {
        if (response.status) {
          var msg =
            (response.description || response.message || '').trim() ||
            (typeof window.cartStrings !== 'undefined' && window.cartStrings.error
              ? window.cartStrings.error
              : 'Could not add to cart');
          window.alert(msg);
          btn.removeAttribute('aria-disabled');
          btn.classList.remove('lcpl__cta--loading');
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function () {
        var err =
          typeof window.cartStrings !== 'undefined' && window.cartStrings.error
            ? window.cartStrings.error
            : 'Could not add to cart';
        window.alert(err);
        btn.removeAttribute('aria-disabled');
        btn.classList.remove('lcpl__cta--loading');
      });
  }

  function lcplOnDocumentClickBuyNow(e) {
    var btn = e.target.closest('[data-lcpl-buy-now]');
    if (!btn || !btn.closest('[data-lcpl-carousel]')) return;
    e.preventDefault();
    e.stopPropagation();
    lcplSubmitBuyNow(btn);
  }

  if (!window.__lcplBuyNowBound) {
    window.__lcplBuyNowBound = true;
    document.addEventListener('click', lcplOnDocumentClickBuyNow);
  }

  var LCPL_HOT_CACHE_KEY = 'lcplHotUrgencyV1';

  function lcplUrgencyNumbers(pid) {
    var id = Math.abs(parseInt(String(pid), 10) || 0);
    var n = (id % 23) + 3;
    var m = ((id % 198) * (4177 % 198)) % 198;
    if (m < 0) m += 198;
    m += 12;
    if (n === m) m += 7;
    return { n: n, m: m };
  }

  function lcplFillHotTemplates(tpl1, tpl2, n, m) {
    function one(t) {
      if (t == null) return '';
      return String(t).replace(/\{n\}/g, String(n)).replace(/\{m\}/g, String(m));
    }
    return { line1: one(tpl1), line2: one(tpl2) };
  }

  function lcplHydrateHotUrgency(root) {
    var el = root && root.querySelectorAll ? root : document;
    var nodes = el.querySelectorAll('[data-lcpl-hot-meta][data-product-id]');
    var map = {};
    try {
      map = JSON.parse(localStorage.getItem(LCPL_HOT_CACHE_KEY) || '{}');
    } catch (e) {
      map = {};
    }
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-lcpl-dynamic') !== '1') continue;
      var id = el.getAttribute('data-product-id');
      var t1 = el.getAttribute('data-lcpl-t1') || '';
      var t2 = el.getAttribute('data-lcpl-t2') || '';
      var domN = parseInt(el.getAttribute('data-lcpl-n'), 10);
      var domM = parseInt(el.getAttribute('data-lcpl-m'), 10);
      var n;
      var m;
      if (map[id] && typeof map[id].n === 'number' && typeof map[id].m === 'number') {
        n = map[id].n;
        m = map[id].m;
      } else if (!isNaN(domN) && !isNaN(domM)) {
        n = domN;
        m = domM;
        map[id] = { n: n, m: m };
      } else {
        var u = lcplUrgencyNumbers(id);
        n = u.n;
        m = u.m;
        map[id] = { n: n, m: m };
      }
      var filled = lcplFillHotTemplates(t1, t2, n, m);
      var p1 = el.querySelector('[data-lcpl-hot-idx="1"]');
      var p2 = el.querySelector('[data-lcpl-hot-idx="2"]');
      if (p1 && t1) p1.textContent = filled.line1;
      if (p2 && t2) p2.textContent = filled.line2;
    }
    try {
      localStorage.setItem(LCPL_HOT_CACHE_KEY, JSON.stringify(map));
    } catch (e) {}
  }

  function lcplPad2(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /** End time persisted on the node so Swiper destroy/rebuild (same seed) keeps one deadline. */
  function lcplEnsureCountdownEndMs(el) {
    var v = el.getAttribute('data-lcpl-countdown-end');
    if (v) {
      var parsed = parseInt(v, 10);
      if (!isNaN(parsed)) return parsed;
    }
    var seed = parseInt(el.getAttribute('data-lcpl-countdown-seed'), 10) || 0;
    var end = Date.now() + 57600000 + (Math.abs(seed) % 28800000);
    el.setAttribute('data-lcpl-countdown-end', String(end));
    return end;
  }

  var lcplCountdownGlobalInterval = null;

  function lcplTickAllCountdowns() {
    var nodes = document.querySelectorAll('[data-lcpl-countdown-seed]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var end = lcplEnsureCountdownEndMs(el);
      var display = el.querySelector('[data-lcpl-countdown-display]');
      if (!display) continue;
      var rem = Math.max(0, end - Date.now());
      if (rem <= 0) {
        display.textContent = '00:00:00';
        continue;
      }
      var h = Math.floor(rem / 3600000);
      var m = Math.floor((rem % 3600000) / 60000);
      var s = Math.floor((rem % 60000) / 1000);
      display.textContent = lcplPad2(h) + ':' + lcplPad2(m) + ':' + lcplPad2(s);
    }
  }

  /**
   * One global interval: survives Swiper rebuild (per-slide timers were updating detached nodes).
   * Call after DOM changes (e.g. applyLcplBatchFromProducts) to prime data-lcpl-countdown-end on new cards.
   */
  function lcplInitCountdowns(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('[data-lcpl-countdown-seed]');
    for (var j = 0; j < nodes.length; j++) {
      lcplEnsureCountdownEndMs(nodes[j]);
    }
    if (!lcplCountdownGlobalInterval) {
      lcplCountdownGlobalInterval = setInterval(lcplTickAllCountdowns, 1000);
    }
    lcplTickAllCountdowns();
  }

  /** products.json variant.price is a decimal string in the presentment currency; match Liquid money filter. */
  function lcplMoneyFormatFromJsonPrice(priceStr) {
    var n = parseFloat(String(priceStr == null ? '' : priceStr));
    if (isNaN(n)) return '';
    var cents = Math.round(n * 100);
    var fmt =
      typeof Shopify !== 'undefined' && Shopify.currency_code_enabled
        ? Shopify.money_with_currency_format
        : Shopify.money_format;
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function' && fmt) {
      return Shopify.formatMoney(cents, fmt);
    }
    return String(priceStr);
  }

  function lcplReadCols(track) {
    var m = parseInt(track.getAttribute('data-lcpl-cols-m') || track.getAttribute('data-lcpl-mobile-pages-per-view') || '2', 10);
    var t = parseInt(track.getAttribute('data-lcpl-cols-t') || '3', 10);
    var d = parseInt(track.getAttribute('data-lcpl-cols-d') || track.getAttribute('data-lcpl-desktop-pages-per-view') || '5', 10);
    return {
      m: isNaN(m) || m < 1 ? 2 : m,
      t: isNaN(t) || t < 1 ? 3 : t,
      d: isNaN(d) || d < 1 ? 5 : d,
    };
  }

  function lcplSwiperPerView(swiper) {
    if (!swiper) return 1;
    var pv = swiper.params.slidesPerView;
    return typeof pv === 'number' && pv >= 1 ? pv : 1;
  }

  function lcplTrackGapPx(track) {
    var g = getComputedStyle(track).gap;
    if (!g || g === 'normal') {
      var root = track.closest ? track.closest('.lcpl') : null;
      if (root) {
        var gv = getComputedStyle(root).getPropertyValue('--lcpl-gap');
        if (gv) {
          var px0 = parseFloat(gv);
          if (!isNaN(px0) && px0 > 0) return px0;
        }
      }
      return 16;
    }
    var px = parseFloat(g);
    return isNaN(px) ? 16 : px;
  }

  function layoutPages(track) {
    if (track._lcplSwiper) {
      track._lcplSwiper.update();
    }
  }

  function measureLcplTrackDom(track) {
    layoutPages(track);
    var slideCount = track.querySelectorAll('[data-lcpl-page]').length;
    var cw = track.clientWidth;
    if (slideCount < 1 || cw <= 0) {
      return { step: 1, pages: 1, perView: 1, maxStart: 0, canPaginate: false };
    }
    var sw = track._lcplSwiper;
    var perView = 1;
    var domMax = 0;
    if (sw && sw.wrapperEl) {
      perView = lcplSwiperPerView(sw);
      domMax = Math.max(0, sw.wrapperEl.scrollWidth - cw);
    } else {
      var pages = track.querySelectorAll('[data-lcpl-page]');
      if (pages.length < 2) {
        return { step: 1, pages: 1, perView: 1, maxStart: 0, canPaginate: false };
      }
      var step = pages[1].offsetLeft - pages[0].offsetLeft;
      if (step <= 0 || !isFinite(step)) {
        return { step: 1, pages: 1, perView: 1, maxStart: 0, canPaginate: false };
      }
      perView = Math.max(1, Math.floor((cw + Number.EPSILON) / step));
      domMax = Math.max(0, track.scrollWidth - cw);
    }
    var pagesNum = Math.max(1, Math.ceil(slideCount / perView));
    var maxStart = Math.max(0, pagesNum - 1);
    var canPaginate = pagesNum >= 2 && domMax > LCPL_SCROLL_EPS && slideCount > perView;
    if (!canPaginate) {
      pagesNum = 1;
      maxStart = 0;
    }
    return {
      step: perView,
      pages: pagesNum,
      perView: perView,
      maxStart: maxStart,
      canPaginate: canPaginate,
    };
  }

  function lcplCappedTotal(track) {
    var total = parseInt(track.getAttribute('data-lcpl-total-products') || '0', 10);
    var cap = parseInt(track.getAttribute('data-lcpl-max-cap') || '9999', 10);
    return Math.min(Math.max(0, total), Math.max(0, cap));
  }

  function lcplHasMoreToLoad(track) {
    var jsonUrl = track.getAttribute('data-lcpl-json-url');
    if (!jsonUrl || !jsonUrl.trim()) return false;
    var loaded = parseInt(track.getAttribute('data-lcpl-loaded-count') || '0', 10);
    return loaded < lcplCappedTotal(track);
  }

  function measurePageTrack(track) {
    var jsonUrl = track.getAttribute('data-lcpl-json-url');
    var capped = lcplCappedTotal(track);
    var cw = track.clientWidth;
    var gapPx = lcplTrackGapPx(track);
    var domMax;
    if (track._lcplSwiper && track._lcplSwiper.wrapperEl) {
      domMax = Math.max(0, track._lcplSwiper.wrapperEl.scrollWidth - cw);
    } else {
      domMax = Math.max(0, track.scrollWidth - cw);
    }

    if (jsonUrl && jsonUrl.trim() && capped > 0) {
      var ppvVirt = 1;
      if (track._lcplSwiper) {
        ppvVirt = lcplSwiperPerView(track._lcplSwiper);
      } else {
        var colsV = lcplReadCols(track);
        if (window.matchMedia('(min-width: 990px)').matches) ppvVirt = colsV.d;
        else if (window.matchMedia('(min-width: 750px)').matches) ppvVirt = colsV.t;
        else ppvVirt = colsV.m;
      }
      // 按当前 DOM 里的 lcpl page 数算页数；勿用 capped 总数（首批 JSON 未加载完时页数会虚高）
      var nSlidesDom = track.querySelectorAll('[data-lcpl-page]').length;
      if (nSlidesDom < 1) nSlidesDom = 1;
      var logicalCount = Math.max(1, Math.ceil(nSlidesDom / ppvVirt));
      var maxStart = Math.max(0, logicalCount - 1);
      var hasMore = lcplHasMoreToLoad(track);
      var canPaginate = hasMore || (logicalCount >= 2 && domMax > LCPL_SCROLL_EPS);
      var step = ppvVirt === 1 ? cw + gapPx : Math.max(1, cw);
      return {
        step: step,
        pages: logicalCount,
        perView: ppvVirt,
        maxStart: maxStart,
        canPaginate: canPaginate,
        virtualTotal: true,
      };
    }

    var dom = measureLcplTrackDom(track);
    return {
      step: dom.step,
      pages: dom.pages,
      perView: dom.perView,
      maxStart: dom.maxStart,
      canPaginate: dom.canPaginate,
      virtualTotal: false,
    };
  }

  function lcplProductImageSrc(product) {
    if (product.images && product.images[0] && product.images[0].src) {
      return product.images[0].src;
    }
    if (product.featured_image) {
      return typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
    }
    if (product.image) {
      return typeof product.image === 'string' ? product.image : product.image.src;
    }
    return '';
  }

  function lcplProductSecondImageSrc(product) {
    if (product.images && product.images[1] && product.images[1].src) {
      return product.images[1].src;
    }
    return '';
  }

  function lcplFirstVariantLikeLiquid(product) {
    var vs = product.variants;
    if (!vs || !vs.length) return {};
    var i;
    for (i = 0; i < vs.length; i++) {
      if (vs[i].available) return vs[i];
    }
    return vs[0];
  }

  function lcplProductIsGiftCard(product) {
    if (!product) return false;
    var pt = (product.product_type && String(product.product_type).toLowerCase()) || '';
    if (pt.indexOf('gift') !== -1) return true;
    return false;
  }

  var LCPL_PROMO_THEMES = [
    { accent: '#E53E3E', ribbon: 'BEST SELLER' },
    { accent: '#ED8936', ribbon: 'TRENDING' },
    { accent: '#38A169', ribbon: 'TOP RATED' },
    { accent: '#3182CE', ribbon: 'FAN FAVORITE' },
    { accent: '#9F7AEA', ribbon: 'LIMITED DROP' },
  ];

  function buildLcplPromoSlideFromProduct(product, track) {
    var pid = product.id;
    var ti = Math.abs(parseInt(String(pid), 10) || 0) % 5;
    var theme = LCPL_PROMO_THEMES[ti];
    var showCta = track.getAttribute('data-lcpl-show-cta') === 'true';
    var ctaLabel = (track.getAttribute('data-lcpl-cta-label') || '').trim() || 'Shop now';
    var previewLabel = track.getAttribute('data-lcpl-label-preview') || 'View';
    var chooseLabel = track.getAttribute('data-lcpl-label-choose') || 'Options';
    var addToCartLabel = track.getAttribute('data-lcpl-add-to-cart') || '';
    var hotT1 = track.getAttribute('data-lcpl-hot-t1');
    var hotT2 = track.getAttribute('data-lcpl-hot-t2');
    var hotDynamic = track.getAttribute('data-lcpl-hot-dynamic') === '1';
    var v = lcplFirstVariantLikeLiquid(product);
    var rawPrice = v.price != null ? String(v.price) : '';
    var rawCompare = v.compare_at_price != null ? String(v.compare_at_price) : '';
    var priceStr = lcplMoneyFormatFromJsonPrice(rawPrice);
    var compareStr = lcplMoneyFormatFromJsonPrice(rawCompare);
    var onSale = rawCompare && parseFloat(rawCompare) > parseFloat(rawPrice || '0');
    var savePct = 0;
    if (onSale) {
      var cpNum = parseFloat(rawCompare);
      var spNum = parseFloat(rawPrice || '0');
      if (cpNum > spNum && cpNum > 0) {
        savePct = Math.min(100, Math.round(((cpNum - spNum) / cpNum) * 100));
      }
    }
    var imgSrc = lcplProductImageSrc(product);
    var imgSrc2 = lcplProductSecondImageSrc(product);
    var pUrl = '/products/' + encodeURIComponent(product.handle || '');
    var sectionId = track.getAttribute('data-lcpl-section-id') || '';
    var cartAddUrl = typeof routes !== 'undefined' && routes.cart_add_url ? routes.cart_add_url : '/cart/add';
    var canQuickAdd =
      v &&
      v.id &&
      v.available !== false &&
      product.available !== false &&
      !lcplProductIsGiftCard(product);
    var formId = 'lcpl-form-' + sectionId + '-' + product.id;
    var addLabel = addToCartLabel && String(addToCartLabel).trim() ? String(addToCartLabel) : 'Add to cart';

    var priceHtml;
    if (onSale && compareStr) {
      priceHtml =
        '<div class="price lcpl__price lcpl__price--promo price--on-sale">' +
        '<div class="price__container">' +
        '<div class="price__regular">' +
        '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
        '<span><s class="price-item price-item--regular">' +
        escapeHtml(compareStr) +
        '</s></span></div>' +
        '<div class="price__sale">' +
        '<span class="visually-hidden visually-hidden--inline">Sale price</span>' +
        '<span class="price-item price-item--sale">' +
        escapeHtml(priceStr) +
        '</span></div></div></div>';
    } else {
      priceHtml =
        '<div class="price lcpl__price lcpl__price--promo"><span class="price-item price-item--regular">' +
        escapeHtml(priceStr) +
        '</span></div>';
    }

    var hotHtml = '';
    var hasHot = (hotT1 && String(hotT1).trim()) || (hotT2 && String(hotT2).trim());
    if (hasHot) {
      var u0 = lcplUrgencyNumbers(pid);
      var hn = u0.n;
      var hm = u0.m;
      var map0 = {};
      try {
        map0 = JSON.parse(localStorage.getItem(LCPL_HOT_CACHE_KEY) || '{}');
      } catch (e) {
        map0 = {};
      }
      var idStr0 = String(pid);
      if (map0[idStr0] && typeof map0[idStr0].n === 'number' && typeof map0[idStr0].m === 'number') {
        hn = map0[idStr0].n;
        hm = map0[idStr0].m;
      }
      var f1 = '';
      var f2 = '';
      if (hotDynamic) {
        var filled0 = lcplFillHotTemplates(hotT1 || '', hotT2 || '', hn, hm);
        f1 = filled0.line1;
        f2 = filled0.line2;
      } else {
        f1 = hotT1 || '';
        f2 = hotT2 || '';
      }
      var pulseClass = hotDynamic ? ' lcpl__hot-meta--pulse' : '';
      hotHtml =
        '<div class="lcpl__hot-meta lcpl__hot-meta--promo' +
        pulseClass +
        '" data-lcpl-hot-meta data-product-id="' +
        escapeHtml(String(pid)) +
        '" data-lcpl-n="' +
        escapeHtml(String(hn)) +
        '" data-lcpl-m="' +
        escapeHtml(String(hm)) +
        '" data-lcpl-dynamic="' +
        (hotDynamic ? '1' : '0') +
        '" data-lcpl-t1="' +
        lcplEscapeAttr(hotT1 || '') +
        '" data-lcpl-t2="' +
        lcplEscapeAttr(hotT2 || '') +
        '">';
      if (hotT1 && String(hotT1).trim()) {
        hotHtml += '<p class="lcpl__hot-line" data-lcpl-hot-idx="1">' + escapeHtml(f1) + '</p>';
      }
      if (hotT2 && String(hotT2).trim()) {
        hotHtml += '<p class="lcpl__hot-line" data-lcpl-hot-idx="2">' + escapeHtml(f2) + '</p>';
      }
      hotHtml += '</div>';
    }

    var cartIconBlock = canQuickAdd
      ? '<product-form class="product-form lcpl__quick-product-form" data-section-id="' +
        escapeHtml(sectionId) +
        '">' +
        '<div class="product-form__error-message-wrapper" role="alert" hidden>' +
        '<span class="svg-wrapper"></span>' +
        '<span class="product-form__error-message"></span></div>' +
        '<form method="post" action="' +
        escapeHtml(cartAddUrl) +
        '" id="' +
        escapeHtml(formId) +
        '" class="form" enctype="multipart/form-data" novalidate data-type="add-to-cart-form" accept-charset="UTF-8">' +
        '<input type="hidden" name="id" value="' +
        escapeHtml(String(v.id)) +
        '" class="product-variant-id">' +
        '<button type="submit" name="add" class="lcpl__quick-add-btn" aria-label="' +
        escapeHtml(addLabel) +
        '">' +
        '<span class="visually-hidden">' +
        escapeHtml(addLabel) +
        '</span><span class="lcpl__quick-add-btn-svg" aria-hidden="true">' +
        LCPL_CART_SVG +
        '</span><div class="loading__spinner hidden">' +
        LCPL_SPINNER_SVG +
        '</div></button></form></product-form>'
      : '<a href="' +
        escapeHtml(pUrl) +
        '" class="lcpl__quick-add-btn" aria-label="' +
        escapeHtml(chooseLabel) +
        '">' +
        '<span class="visually-hidden">' +
        escapeHtml(chooseLabel) +
        '</span><span class="lcpl__quick-add-btn-svg" aria-hidden="true">' +
        LCPL_CART_SVG +
        '</span></a>';

    var quickIconsPromo =
      '<div class="lcpl__quick-icons lcpl__quick-icons--promo">' +
      '<modal-opener data-modal="#QuickAdd-' +
      escapeHtml(sectionId) +
      '">' +
      '<button type="button" class="lcpl__quick-icon lcpl__quick-icon--preview" data-product-url="' +
      escapeHtml(pUrl) +
      '" aria-label="' +
      escapeHtml(previewLabel) +
      '">' +
      '<span class="lcpl__quick-icon-svg" aria-hidden="true">' +
      LCPL_EYE_SVG +
      '</span>' +
      '<div class="loading__spinner hidden">' +
      LCPL_SPINNER_SVG +
      '</div>' +
      '</button></modal-opener>' +
      '</div>' +
      '<div class="lcpl__quick-add lcpl__quick-add--promo">' +
      cartIconBlock +
      '</div>';

    var mediaInner =
      imgSrc
        ? '<span class="lcpl__media-img-stack">' +
          '<img class="lcpl__img lcpl__img--primary" loading="lazy" src="' +
          escapeHtml(imgSrc) +
          '" alt="' +
          escapeHtml(product.title || '') +
          '" width="900" height="900" sizes="(min-width: 990px) 16vw, (min-width: 750px) 17vw, 46vw">' +
          (imgSrc2
            ? '<img class="lcpl__img lcpl__img--secondary" loading="lazy" src="' +
              escapeHtml(imgSrc2) +
              '" alt="" width="900" height="900" sizes="(min-width: 990px) 16vw, (min-width: 750px) 17vw, 46vw" aria-hidden="true">'
            : '') +
          '</span>'
        : '<span class="lcpl__img lcpl__img--placeholder" aria-hidden="true"></span>';

    var discHtml =
      savePct > 0
        ? '<span class="lcpl__promo-disc" aria-hidden="true">-' + escapeHtml(String(savePct)) + '%</span>'
        : '';

    var pt = (product.product_type && String(product.product_type).trim()) || '';
    var subtitle = pt ? escapeHtml(pt) + ' · Fan Version' : 'Fan Version';
    var revCount = (Math.abs(parseInt(String(pid), 10) || 0) % 156) + 14;

    var ctaBlock = '';
    if (showCta && ctaLabel) {
      if (canQuickAdd) {
        ctaBlock =
          '<button type="button" class="lcpl__cta lcpl__cta--promo lcpl__cta--checkout" data-lcpl-buy-now data-variant-id="' +
          escapeHtml(String(v.id)) +
          '"><span class="lcpl__cta-label">' +
          escapeHtml(ctaLabel) +
          '</span></button>';
      } else {
        ctaBlock =
          '<a class="lcpl__cta lcpl__cta--promo" href="' +
          escapeHtml(pUrl) +
          '"><span class="lcpl__cta-label">' +
          escapeHtml(ctaLabel) +
          '</span></a>';
      }
    }

    var slide = document.createElement('div');
    slide.className = 'lcpl__slide';
    slide.setAttribute('role', 'listitem');
    slide.innerHTML =
      '<div class="lcpl__card lcpl__card--promo" style="--lcpl-accent: ' +
      theme.accent +
      '">' +
      '<div class="lcpl__media lcpl__media--promo">' +
      '<a class="lcpl__media-link" href="' +
      escapeHtml(pUrl) +
      '">' +
      mediaInner +
      '</a>' +
      '<span class="lcpl__promo-ribbon">' +
      escapeHtml(theme.ribbon) +
      '</span>' +
      discHtml +
      quickIconsPromo +
      '<div class="lcpl__countdown" data-lcpl-countdown data-lcpl-countdown-seed="' +
      escapeHtml(String(pid)) +
      '">' +
      '<span class="lcpl__countdown-label">Sale ends in:</span>' +
      '<span class="lcpl__countdown-digits" data-lcpl-countdown-display>00:00:00</span>' +
      '</div></div>' +
      '<div class="lcpl__card-body lcpl__card-body--promo">' +
      '<a class="lcpl__card-body-link lcpl__card-body-link--promo" href="' +
      escapeHtml(pUrl) +
      '">' +
      '<h3 class="lcpl__title lcpl__title--promo">' +
      escapeHtml(product.title || '') +
      '</h3>' +
      '<p class="lcpl__subtitle">' +
      subtitle +
      '</p>' +
      '<div class="lcpl__rating-row">' +
      '<span class="lcpl__stars-fake" aria-hidden="true">★★★★★</span>' +
      '<span class="lcpl__rating-count">(' +
      revCount +
      ')</span></div>' +
      '<div class="lcpl__price-wrap lcpl__price-wrap--promo">' +
      priceHtml +
      '</div>' +
      hotHtml +
      '</a>' +
      ctaBlock +
      '</div></div>';

    return slide;
  }

  function buildLcplSlideFromProduct(product, track) {
    if (track.getAttribute('data-lcpl-promo-cards') === '1') {
      return buildLcplPromoSlideFromProduct(product, track);
    }
    var showCta = track.getAttribute('data-lcpl-show-cta') === 'true';
    var ctaLabel = (track.getAttribute('data-lcpl-cta-label') || '').trim() || 'Shop now';
    var previewLabel = track.getAttribute('data-lcpl-label-preview') || 'View';
    var chooseLabel = track.getAttribute('data-lcpl-label-choose') || 'Options';
    var pctOffTemplate = track.getAttribute('data-lcpl-pct-off-template') || '';
    var addToCartLabel = track.getAttribute('data-lcpl-add-to-cart') || '';
    var v = lcplFirstVariantLikeLiquid(product);
    var rawPrice = v.price != null ? String(v.price) : '';
    var rawCompare = v.compare_at_price != null ? String(v.compare_at_price) : '';
    var priceStr = lcplMoneyFormatFromJsonPrice(rawPrice);
    var compareStr = lcplMoneyFormatFromJsonPrice(rawCompare);
    var onSale = rawCompare && parseFloat(rawCompare) > parseFloat(rawPrice || '0');
    var savePct = 0;
    if (onSale) {
      var cpNum = parseFloat(rawCompare);
      var spNum = parseFloat(rawPrice || '0');
      if (cpNum > spNum && cpNum > 0) {
        savePct = Math.min(100, Math.round(((cpNum - spNum) / cpNum) * 100));
      }
    }
    var pctTpl =
      pctOffTemplate && String(pctOffTemplate).trim() ? String(pctOffTemplate) : '__PCT__% OFF';
    var cornerLabel = pctTpl.replace(/__PCT__/g, String(savePct));
    var cornerTagHtml =
      savePct > 0
        ? '<span class="lcpl__corner-tag" aria-hidden="true">' + escapeHtml(cornerLabel) + '</span>'
        : '';
    var imgSrc = lcplProductImageSrc(product);
    var imgSrc2 = lcplProductSecondImageSrc(product);
    var pUrl = '/products/' + encodeURIComponent(product.handle || '');
    var sectionId = track.getAttribute('data-lcpl-section-id') || '';
    var addLabel = addToCartLabel && String(addToCartLabel).trim() ? String(addToCartLabel) : 'Add to cart';
    var cartAddUrl = typeof routes !== 'undefined' && routes.cart_add_url ? routes.cart_add_url : '/cart/add';
    var canQuickAdd =
      v &&
      v.id &&
      v.available !== false &&
      product.available !== false &&
      !lcplProductIsGiftCard(product);
    var formId = 'lcpl-form-' + sectionId + '-' + product.id;

    var priceHtml;
    if (onSale && compareStr) {
      priceHtml =
        '<div class="price lcpl__price price--on-sale">' +
        '<div class="price__container">' +
        '<div class="price__regular">' +
        '<span class="visually-hidden visually-hidden--inline">Regular price</span>' +
        '<span><s class="price-item price-item--regular">' +
        escapeHtml(compareStr) +
        '</s></span></div>' +
        '<div class="price__sale">' +
        '<span class="visually-hidden visually-hidden--inline">Sale price</span>' +
        '<span class="price-item price-item--sale">' +
        escapeHtml(priceStr) +
        '</span></div></div></div>';
    } else {
      priceHtml =
        '<div class="price lcpl__price"><span class="price-item price-item--regular">' +
        escapeHtml(priceStr) +
        '</span></div>';
    }

    var hotT1 = track.getAttribute('data-lcpl-hot-t1');
    var hotT2 = track.getAttribute('data-lcpl-hot-t2');
    var hotDynamic = track.getAttribute('data-lcpl-hot-dynamic') === '1';
    var hasHot = (hotT1 && String(hotT1).trim()) || (hotT2 && String(hotT2).trim());
    var hotHtml = '';
    if (hasHot) {
      var pid = product.id;
      var u0 = lcplUrgencyNumbers(pid);
      var hn = u0.n;
      var hm = u0.m;
      var map0 = {};
      try {
        map0 = JSON.parse(localStorage.getItem(LCPL_HOT_CACHE_KEY) || '{}');
      } catch (e) {
        map0 = {};
      }
      var idStr0 = String(pid);
      if (map0[idStr0] && typeof map0[idStr0].n === 'number' && typeof map0[idStr0].m === 'number') {
        hn = map0[idStr0].n;
        hm = map0[idStr0].m;
      }
      var f1 = '';
      var f2 = '';
      if (hotDynamic) {
        var filled0 = lcplFillHotTemplates(hotT1 || '', hotT2 || '', hn, hm);
        f1 = filled0.line1;
        f2 = filled0.line2;
      } else {
        f1 = hotT1 || '';
        f2 = hotT2 || '';
      }
      var pulseClass = hotDynamic ? ' lcpl__hot-meta--pulse' : '';
      hotHtml =
        '<div class="lcpl__hot-meta' +
        pulseClass +
        '" data-lcpl-hot-meta data-product-id="' +
        escapeHtml(String(pid)) +
        '" data-lcpl-n="' +
        escapeHtml(String(hn)) +
        '" data-lcpl-m="' +
        escapeHtml(String(hm)) +
        '" data-lcpl-dynamic="' +
        (hotDynamic ? '1' : '0') +
        '" data-lcpl-t1="' +
        lcplEscapeAttr(hotT1 || '') +
        '" data-lcpl-t2="' +
        lcplEscapeAttr(hotT2 || '') +
        '">';
      if (hotT1 && String(hotT1).trim()) {
        hotHtml += '<p class="lcpl__hot-line" data-lcpl-hot-idx="1">' + escapeHtml(f1) + '</p>';
      }
      if (hotT2 && String(hotT2).trim()) {
        hotHtml += '<p class="lcpl__hot-line" data-lcpl-hot-idx="2">' + escapeHtml(f2) + '</p>';
      }
      hotHtml += '</div>';
    }

    var cartIconBlock = canQuickAdd
      ? '<product-form class="product-form lcpl__quick-product-form" data-section-id="' +
        escapeHtml(sectionId) +
        '">' +
        '<div class="product-form__error-message-wrapper" role="alert" hidden>' +
        '<span class="svg-wrapper"></span>' +
        '<span class="product-form__error-message"></span></div>' +
        '<form method="post" action="' +
        escapeHtml(cartAddUrl) +
        '" id="' +
        escapeHtml(formId) +
        '" class="form" enctype="multipart/form-data" novalidate data-type="add-to-cart-form" accept-charset="UTF-8">' +
        '<input type="hidden" name="id" value="' +
        escapeHtml(String(v.id)) +
        '" class="product-variant-id">' +
        '<button type="submit" name="add" class="lcpl__quick-add-btn" aria-label="' +
        escapeHtml(addLabel) +
        '">' +
        '<span class="visually-hidden">' +
        escapeHtml(addLabel) +
        '</span><span class="lcpl__quick-add-btn-svg" aria-hidden="true">' +
        LCPL_CART_SVG +
        '</span><div class="loading__spinner hidden">' +
        LCPL_SPINNER_SVG +
        '</div></button></form></product-form>'
      : '<a href="' +
        escapeHtml(pUrl) +
        '" class="lcpl__quick-add-btn" aria-label="' +
        escapeHtml(chooseLabel) +
        '">' +
        '<span class="visually-hidden">' +
        escapeHtml(chooseLabel) +
        '</span><span class="lcpl__quick-add-btn-svg" aria-hidden="true">' +
        LCPL_CART_SVG +
        '</span></a>';

    var quickIcons =
      '<div class="lcpl__quick-icons">' +
      '<modal-opener data-modal="#QuickAdd-' +
      escapeHtml(sectionId) +
      '">' +
      '<button type="button" class="lcpl__quick-icon lcpl__quick-icon--preview" data-product-url="' +
      escapeHtml(pUrl) +
      '" aria-label="' +
      escapeHtml(previewLabel) +
      '">' +
      '<span class="lcpl__quick-icon-svg" aria-hidden="true">' +
      LCPL_EYE_SVG +
      '</span>' +
      '<div class="loading__spinner hidden">' +
      LCPL_SPINNER_SVG +
      '</div>' +
      '</button></modal-opener>' +
      '</div>' +
      '<div class="lcpl__quick-add">' +
      cartIconBlock +
      '</div>';

    var slide = document.createElement('div');
    slide.className = 'lcpl__slide';
    slide.setAttribute('role', 'listitem');
    var mediaInner = imgSrc
      ? '<span class="lcpl__media-img-stack">' +
        '<img class="lcpl__img lcpl__img--primary" loading="lazy" src="' +
        escapeHtml(imgSrc) +
        '" alt="' +
        escapeHtml(product.title || '') +
        '" width="900" height="900" sizes="(min-width: 990px) 16vw, (min-width: 750px) 17vw, 46vw">' +
        (imgSrc2
          ? '<img class="lcpl__img lcpl__img--secondary" loading="lazy" src="' +
            escapeHtml(imgSrc2) +
            '" alt="" width="900" height="900" sizes="(min-width: 990px) 16vw, (min-width: 750px) 17vw, 46vw" aria-hidden="true">'
          : '') +
        '</span>'
      : '<span class="lcpl__img lcpl__img--placeholder" aria-hidden="true"></span>';

    var ctaBlock = '';
    if (showCta && ctaLabel) {
      if (canQuickAdd) {
        ctaBlock =
          '<button type="button" class="lcpl__cta lcpl__cta--checkout" data-lcpl-buy-now data-variant-id="' +
          escapeHtml(String(v.id)) +
          '">' +
          escapeHtml(ctaLabel) +
          '</button>';
      } else {
        ctaBlock =
          '<a class="lcpl__cta" href="' + escapeHtml(pUrl) + '">' + escapeHtml(ctaLabel) + '</a>';
      }
    }

    slide.innerHTML =
      '<div class="lcpl__card">' +
      '<div class="lcpl__media">' +
      '<a class="lcpl__media-link" href="' +
      escapeHtml(pUrl) +
      '">' +
      mediaInner +
      '</a>' +
      cornerTagHtml +
      quickIcons +
      '</div>' +
      '<div class="lcpl__card-body">' +
      '<a class="lcpl__card-body-link" href="' +
      escapeHtml(pUrl) +
      '">' +
      '<h3 class="lcpl__title">' +
      escapeHtml(product.title || '') +
      '</h3>' +
      hotHtml +
      '<div class="lcpl__price-wrap">' +
      priceHtml +
      '</div>' +
      '</a>' +
      ctaBlock +
      '</div></div>';

    return slide;
  }

  function appendLcplProducts(track, products) {
    var chunk = parseInt(track.getAttribute('data-lcpl-chunk') || '1', 10);
    var wrap = track.querySelector('.swiper-wrapper');
    var pages = track.querySelectorAll('[data-lcpl-page]');
    var lastPage = pages.length ? pages[pages.length - 1] : null;
    var slidesInLast = lastPage ? lastPage.querySelectorAll('.lcpl__slide').length : 0;
    var frag = document.createDocumentFragment();
    var pageEl = null;
    var inPage = 0;

    if (lastPage && slidesInLast > 0 && slidesInLast < chunk) {
      pageEl = lastPage;
      inPage = slidesInLast;
    }

    for (var i = 0; i < products.length; i++) {
      if (!pageEl || inPage >= chunk) {
        pageEl = document.createElement('div');
        pageEl.className = 'swiper-slide lcpl__page';
        pageEl.setAttribute('data-lcpl-page', '');
        pageEl.setAttribute('role', 'group');
        frag.appendChild(pageEl);
        inPage = 0;
      }
      pageEl.appendChild(buildLcplSlideFromProduct(products[i], track));
      inPage++;
    }
    if (wrap) {
      wrap.appendChild(frag);
    } else {
      track.appendChild(frag);
    }
  }

  function fetchLcplProductsPage(baseUrl, pageNum, limit) {
    var sep = baseUrl.indexOf('?') >= 0 ? '&' : '?';
    var url = baseUrl + sep + 'limit=' + limit + '&page=' + pageNum;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('lcpl fetch');
        return r.json();
      })
      .then(function (data) {
        return data.products || [];
      });
  }

  function applyLcplBatchFromProducts(track, products) {
    var capped = lcplCappedTotal(track);
    var loaded = parseInt(track.getAttribute('data-lcpl-loaded-count') || '0', 10);
    if (!products || !products.length) {
      track.removeAttribute('data-lcpl-json-url');
      return;
    }
    var take = Math.min(products.length, Math.max(0, capped - loaded));
    if (take <= 0) {
      track.removeAttribute('data-lcpl-json-url');
      return;
    }
    var slice = products.slice(0, take);
    appendLcplProducts(track, slice);
    var rootCarousel = track.closest('[data-lcpl-carousel]');
    if (rootCarousel) {
      lcplHydrateHotUrgency(rootCarousel);
      lcplInitCountdowns(rootCarousel);
    }
    var newLoaded = loaded + slice.length;
    track.setAttribute('data-lcpl-loaded-count', String(newLoaded));
    if (newLoaded >= capped) {
      track.removeAttribute('data-lcpl-json-url');
    }
  }

  function scheduleLcplPrefetchAfterApply(track) {
    if (!lcplHasMoreToLoad(track)) return;
    var run = function () {
      prefetchLcplNextBatch(track);
    };
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(run, { timeout: LCPL_PREFETCH_IDLE_TIMEOUT_MS });
    } else {
      window.setTimeout(run, 140);
    }
  }

  function scheduleLcplPrefetchDeferred(track) {
    if (!lcplHasMoreToLoad(track)) return;
    window.clearTimeout(track._lcplDeferredPrefetchTimer);
    if (typeof window.cancelIdleCallback === 'function' && track._lcplPrefetchIdleId != null) {
      window.cancelIdleCallback(track._lcplPrefetchIdleId);
      track._lcplPrefetchIdleId = null;
    }
    var run = function () {
      track._lcplPrefetchIdleId = null;
      prefetchLcplNextBatch(track);
    };
    if (typeof window.requestIdleCallback === 'function') {
      track._lcplPrefetchIdleId = window.requestIdleCallback(run, { timeout: LCPL_PREFETCH_IDLE_TIMEOUT_MS });
    } else {
      track._lcplDeferredPrefetchTimer = window.setTimeout(run, LCPL_PREFETCH_FALLBACK_DELAY_MS);
    }
  }

  function prefetchLcplNextBatch(track) {
    if (!lcplHasMoreToLoad(track)) return;
    if (track.getAttribute('data-lcpl-loading') === '1') return;
    var jsonUrl = track.getAttribute('data-lcpl-json-url');
    if (!jsonUrl) return;
    var batch = parseInt(track.getAttribute('data-lcpl-batch-size') || '6', 10);
    var loaded = parseInt(track.getAttribute('data-lcpl-loaded-count') || '0', 10);
    var capped = lcplCappedTotal(track);
    if (loaded >= capped) return;
    var pref = track._lcplPrefetchReady;
    if (pref && pref.snapshot === loaded) return;
    if (track._lcplPrefetchPromise) return;
    var pageNum = Math.floor(loaded / batch) + 1;
    var snapshot = loaded;
    track._lcplPrefetchPromise = fetchLcplProductsPage(jsonUrl, pageNum, batch)
      .then(function (products) {
        track._lcplPrefetchPromise = null;
        if (!products || !products.length) return;
        var cur = parseInt(track.getAttribute('data-lcpl-loaded-count') || '0', 10);
        if (cur !== snapshot) return;
        track._lcplPrefetchReady = { snapshot: snapshot, products: products };
      })
      .catch(function () {
        track._lcplPrefetchPromise = null;
      });
  }

  function fetchAppendLcpl(track, group, onDone) {
    var jsonUrl = track.getAttribute('data-lcpl-json-url');
    if (!jsonUrl) {
      if (onDone) onDone();
      return;
    }
    var batch = parseInt(track.getAttribute('data-lcpl-batch-size') || '6', 10);
    var loaded = parseInt(track.getAttribute('data-lcpl-loaded-count') || '0', 10);
    var capped = lcplCappedTotal(track);
    if (loaded >= capped) {
      if (onDone) onDone();
      return;
    }

    var cached = track._lcplPrefetchReady;
    if (cached && cached.snapshot === loaded && cached.products && cached.products.length) {
      track._lcplPrefetchReady = null;
      applyLcplBatchFromProducts(track, cached.products);
      if (typeof track._lcplRebuild === 'function') {
        track._lcplRebuild();
      }
      scheduleLcplPrefetchAfterApply(track);
      if (onDone) onDone();
      return;
    }

    if (track._lcplPrefetchPromise) {
      track._lcplPrefetchPromise
        .then(function () {
          fetchAppendLcpl(track, group, onDone);
        })
        .catch(function () {
          fetchAppendLcpl(track, group, onDone);
        });
      return;
    }

    if (track.getAttribute('data-lcpl-loading') === '1') {
      window.setTimeout(function () {
        fetchAppendLcpl(track, group, onDone);
      }, 48);
      return;
    }

    var pageNum = Math.floor(loaded / batch) + 1;
    track.setAttribute('data-lcpl-loading', '1');
    track._lcplPrefetchReady = null;
    fetchLcplProductsPage(jsonUrl, pageNum, batch)
      .then(function (products) {
        applyLcplBatchFromProducts(track, products);
        if (typeof track._lcplRebuild === 'function') {
          track._lcplRebuild();
        }
        scheduleLcplPrefetchAfterApply(track);
        if (onDone) onDone();
      })
      .catch(function () {
        if (onDone) onDone();
      })
      .finally(function () {
        track.removeAttribute('data-lcpl-loading');
      });
  }

  function loadMoreUntilSlide(track, group, targetSlideIndex, done) {
    var n = track.querySelectorAll('[data-lcpl-page]').length;
    if (n > targetSlideIndex) {
      if (done) done();
      return;
    }
    if (!lcplHasMoreToLoad(track)) {
      if (done) done();
      return;
    }
    if (track.getAttribute('data-lcpl-loading') === '1') {
      window.requestAnimationFrame(function () {
        loadMoreUntilSlide(track, group, targetSlideIndex, done);
      });
      return;
    }
    fetchAppendLcpl(track, group, function () {
      loadMoreUntilSlide(track, group, targetSlideIndex, done);
    });
  }

  function bindGroup(group) {
    if (group.getAttribute('data-lcpl-js') === '1') {
      refreshGroup(group);
      return;
    }

    var track = group.querySelector('[data-lcpl-track]');
    var prev = group.querySelector('[data-lcpl-prev]');
    var next = group.querySelector('[data-lcpl-next]');
    var dotsWrap = group.querySelector('[data-lcpl-dots]');
    if (!track || !prev || !next || !dotsWrap) return;
    if (typeof Swiper === 'undefined') {
      return;
    }

    group.setAttribute('data-lcpl-js', '1');

    var state = {
      step: 0,
      pages: 1,
      perView: 1,
      maxStart: 0,
      canPaginate: false,
      virtualTotal: false,
    };

    function destroyLcplSwiper() {
      if (track._lcplSwiper) {
        track._lcplSwiper.destroy(true, true);
        track._lcplSwiper = null;
      }
    }

    function makeLcplSwiper() {
      destroyLcplSwiper();
      var gapPx = lcplTrackGapPx(track);
      var cols = lcplReadCols(track);
      var swiper = new Swiper(track, {
        slidesPerView: cols.m,
        slidesPerGroup: cols.m,
        spaceBetween: gapPx,
        watchOverflow: true,
        nested: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          750: {
            slidesPerView: cols.t,
            slidesPerGroup: cols.t,
            spaceBetween: gapPx,
          },
          990: {
            slidesPerView: cols.d,
            slidesPerGroup: cols.d,
            spaceBetween: gapPx,
          },
        },
        on: {
          slideChange: function () {
            updateUi();
          },
          reachEnd: function () {
            if (lcplHasMoreToLoad(track)) {
              prefetchLcplNextBatch(track);
            }
          },
        },
      });
      track._lcplSwiper = swiper;
      return swiper;
    }

    function rebuildDots() {
      if (track._lcplSwiper) {
        track._lcplSwiper.update();
      } else {
        makeLcplSwiper();
      }

      var m = measurePageTrack(track);
      state.step = m.step;
      state.pages = m.pages;
      state.perView = m.perView;
      state.maxStart = m.maxStart;
      state.canPaginate = !!m.canPaginate;
      state.virtualTotal = !!m.virtualTotal;
      if (track._lcplSwiper) {
        track._lcplSwiper.update();
      }

      dotsWrap.innerHTML = '';
      var showDots = state.canPaginate && state.pages >= 2;
      dotsWrap.setAttribute('aria-hidden', showDots ? 'false' : 'true');
      if (showDots) {
        for (var p = 0; p < state.pages; p++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'lcpl__dot';
          b.setAttribute('aria-label', 'Page ' + (p + 1));
          (function (pageIndex) {
            b.addEventListener('click', function () {
              var sw = track._lcplSwiper;
              if (!sw) return;
              if (!state.canPaginate && !state.virtualTotal) return;
              var pv = lcplSwiperPerView(sw);
              var nPhys = sw.slides.length;
              var rawTarget =
                pageIndex >= state.pages - 1 ? Math.max(0, nPhys - pv) : pageIndex * pv;
              if (rawTarget >= nPhys) {
                if (lcplHasMoreToLoad(track)) {
                  loadMoreUntilSlide(track, group, rawTarget, function () {
                    window.requestAnimationFrame(function () {
                      if (track._lcplSwiper) {
                        track._lcplSwiper.update();
                        var sw2 = track._lcplSwiper;
                        var n2 = sw2.slides.length;
                        var pv2 = lcplSwiperPerView(sw2);
                        var lastStart2 = Math.max(0, n2 - pv2);
                        var t2 =
                          pageIndex >= state.pages - 1
                            ? lastStart2
                            : Math.min(pageIndex * pv2, lastStart2);
                        sw2.slideTo(t2);
                      }
                      updateUi();
                    });
                  });
                  return;
                }
                sw.slideTo(Math.max(0, nPhys - pv));
                return;
              }
              var lastStart = Math.max(0, nPhys - pv);
              var target =
                pageIndex >= state.pages - 1
                  ? lastStart
                  : Math.min(pageIndex * pv, lastStart);
              sw.slideTo(target);
            });
          })(p);
          dotsWrap.appendChild(b);
        }
      }
      updateUi();
      if (lcplHasMoreToLoad(track)) {
        window.clearTimeout(track._lcplRebuildPrefetchDebounce);
        track._lcplRebuildPrefetchDebounce = window.setTimeout(function () {
          if (lcplHasMoreToLoad(track)) {
            scheduleLcplPrefetchDeferred(track);
          }
        }, 220);
      }
      var lcplRootAfterRebuild = track.closest('[data-lcpl-carousel]');
      if (lcplRootAfterRebuild) {
        lcplInitCountdowns(lcplRootAfterRebuild);
      }
    }

    function updateUi() {
      var swiper = track._lcplSwiper;
      var hasMore = lcplHasMoreToLoad(track);
      if (!state.step || state.step <= 0 || !state.canPaginate) {
        prev.setAttribute('aria-disabled', 'true');
        next.setAttribute('aria-disabled', 'true');
        if (state.pages < 2) return;
        var dots0 = dotsWrap.querySelectorAll('.lcpl__dot');
        for (var j = 0; j < dots0.length; j++) {
          dots0[j].classList.remove('is-active');
        }
        return;
      }

      if (!swiper) return;

      var pv = lcplSwiperPerView(swiper);
      var nSlideEls = swiper.slides.length;
      var ai = swiper.activeIndex;
      var idx = Math.min(state.maxStart, Math.max(0, Math.floor(ai / pv)));
      if (nSlideEls > 0 && ai + pv >= nSlideEls) {
        var lastPageFromSlides = Math.max(0, Math.ceil(nSlideEls / pv) - 1);
        idx = Math.min(state.maxStart, lastPageFromSlides);
      }
      var atStart = swiper.isBeginning;
      var atEnd = swiper.isEnd;

      if (state.virtualTotal && hasMore && atEnd) {
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        next.setAttribute('aria-disabled', 'false');
      } else if (nSlideEls <= pv) {
        prev.setAttribute('aria-disabled', 'true');
        next.setAttribute('aria-disabled', 'true');
      } else {
        prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
        next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
      }

      if (state.pages < 2 || !state.canPaginate) return;
      var dots = dotsWrap.querySelectorAll('.lcpl__dot');
      var dotIdx = Math.min(dots.length - 1, Math.max(0, idx));
      if (atEnd && dots.length > 0) {
        dotIdx = dots.length - 1;
      }
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === dotIdx);
      }
    }

    prev.addEventListener('click', function () {
      var sw = track._lcplSwiper;
      if (!sw || !state.canPaginate) return;
      sw.slidePrev();
    });

    next.addEventListener('click', function () {
      var sw = track._lcplSwiper;
      if (!sw) return;
      if (lcplHasMoreToLoad(track) && sw.isEnd) {
        if (track.getAttribute('data-lcpl-loading') === '1') return;
        fetchAppendLcpl(track, group, function () {
          rebuildDots();
        });
        return;
      }
      if (!state.canPaginate) return;
      sw.slideNext();
    });

    function prefetchOnNextIntent() {
      prefetchLcplNextBatch(track);
    }
    next.addEventListener('pointerenter', prefetchOnNextIntent);
    next.addEventListener('focus', prefetchOnNextIntent);
    var ro = new ResizeObserver(function () {
      rebuildDots();
    });
    ro.observe(track);

    var mql = window.matchMedia('(min-width: 750px)');
    function onLcplBreakpoint() {
      destroyLcplSwiper();
      rebuildDots();
    }
    if (mql.addEventListener) {
      mql.addEventListener('change', onLcplBreakpoint);
    } else if (mql.addListener) {
      mql.addListener(onLcplBreakpoint);
    }

    var mql990 = window.matchMedia('(min-width: 990px)');
    function onLcplBreakpoint990() {
      destroyLcplSwiper();
      rebuildDots();
    }
    if (mql990.addEventListener) {
      mql990.addEventListener('change', onLcplBreakpoint990);
    } else if (mql990.addListener) {
      mql990.addListener(onLcplBreakpoint990);
    }

    group._lcplRefresh = function () {
      rebuildDots();
    };
    track._lcplRebuild = rebuildDots;
    rebuildDots();
  }

  function refreshGroup(group) {
    if (typeof group._lcplRefresh === 'function') {
      group._lcplRefresh();
    }
  }

  function syncAllianceLeague(root, leagueIndex) {
    if (root.getAttribute('data-lcpl-alliance-sync') !== '1') return;
    var groups = root.querySelectorAll('[data-lcpl-group][data-lcpl-alliance-league]');
    if (!groups.length) return;
    var idx = Math.max(0, Math.min(leagueIndex, groups.length - 1));
    groups.forEach(function (g) {
      var id = g.getAttribute('data-lcpl-alliance-league');
      var on = String(id) === String(idx);
      g.hidden = !on;
      if (on) {
        var tr = g.querySelector('[data-lcpl-track]');
        if (tr) {
          if (tr._lcplSwiper) tr._lcplSwiper.slideTo(0);
          else tr.scrollLeft = 0;
        }
        bindGroup(g);
        window.requestAnimationFrame(function () {
          refreshGroup(g);
        });
      }
    });
  }

  /** Hot urgency + countdown must not wait for homeCarouselDefer (below-fold IO); otherwise digits stay 00:00:00 until scroll. */
  function initLcplHotAndCountdown(root) {
    lcplHydrateHotUrgency(root);
    lcplInitCountdowns(root);
  }

  function initLcplCarouselBindings(root) {
    root.querySelectorAll('[data-lcpl-group]').forEach(function (g) {
      if (!g.hidden) bindGroup(g);
    });
  }

  function scan(container) {
    (container.querySelectorAll('[data-lcpl-carousel]') || []).forEach(function (root) {
      initLcplHotAndCountdown(root);
      var runCarousel = function () {
        initLcplCarouselBindings(root);
      };
      if (window.homeCarouselDefer && typeof window.homeCarouselDefer.whenReady === 'function') {
        window.homeCarouselDefer.whenReady(root, runCarousel);
      } else {
        runCarousel();
      }
    });
  }

  if (!window.__lcplCarouselListeners) {
    window.__lcplCarouselListeners = true;
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target) scan(e.target);
    });
    document.addEventListener('theme:alliance-league-change', function (e) {
      var d = e.detail || {};
      var li =
        typeof d.leagueIndex === 'number'
          ? d.leagueIndex
          : parseInt(String(d.leagueIndex), 10);
      if (isNaN(li)) return;
      document.querySelectorAll('[data-lcpl-carousel][data-lcpl-alliance-sync="1"]').forEach(function (root) {
        syncAllianceLeague(root, li);
      });
    });
  } else {
    scan(document);
  }

  if (document.readyState !== 'loading') {
    scan(document);
  }

  window.lcplRebuild = function (trackOrSelector) {
    var track =
      typeof trackOrSelector === 'string'
        ? document.querySelector(trackOrSelector)
        : trackOrSelector;
    if (!track || track.getAttribute('data-lcpl-track') == null) return;
    if (typeof track._lcplRebuild === 'function') {
      track._lcplRebuild();
    }
  };
})();
